import React from 'react';
import MdsDashboardGuard from 'src/sections/dashboard/mds-dashboard/mds-dashboard-guard';
import MdsPatientList from 'src/sections/dashboard/mds-dashboard/mds-patient-list';

/** BRK-1851: the MDS Dashboard patient list (guard enforces flag + permission). */
const MdsDashboard: React.FC = () => {
  return (
    <MdsDashboardGuard>
      <MdsPatientList />
    </MdsDashboardGuard>
  );
};

export default MdsDashboard;
